import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/js': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM243.8 381.4v-143.7h-42.1v143.1c0 21.1-8.8 26.5-22.6 26.5-14.5 0-20.5-9.9-27.1-21.6l-34.3 20.7c10 21.1 29.5 38.5 63.2 38.5 37.3 0 62.9-19.9 62.9-63.5zM343.4 444.9c39.9 0 69.7-20.8 69.7-58.6 0-35.2-20.1-50.9-55.9-66.2l-10.5-4.5c-18.1-7.9-25.9-13-25.9-25.6 0-10.2 7.8-18 20.1-18 12.1 0 19.9 5.1 27.1 18l32.8-21c-13.8-24.4-33-33.7-59.8-33.7-37.5 0-61.6 24-61.6 55.6 0 34.3 20.1 50.6 50.5 63.5l10.5 4.5c19.3 8.5 30.7 13.6 30.7 28 0 12.1-11.2 20.8-28.6 20.8-20.7 0-32.5-10.9-41.5-25.6l-34.3 19.8c12.3 24.4 37.6 43 76.7 43z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/js.js
// module id = 904
// module chunks = 0